import React from "react";
import { Alert, Button, Spinner } from "react-bootstrap";

const GuestStatusCard = ({
  variant,
  title,
  message,
  busy = false,
  actionLabel,
  onAction,
  dismissible = false,
  onDismiss,
  children,
}) => {
  const liveRole = variant === "danger" ? "alert" : "status";
  const liveMode = variant === "danger" ? "assertive" : "polite";

  return (
    <Alert
      variant={variant}
      dismissible={dismissible}
      onClose={onDismiss}
      role={liveRole}
      aria-live={liveMode}
      className="shadow-sm guest-status-card"
    >
      <div className="d-flex align-items-start">
        {busy && (
          <Spinner
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
            className="me-2 mt-1 flex-shrink-0"
          />
        )}
        <div className="flex-grow-1">
          <div className="fw-bold mb-1">{title}</div>
          <div style={{ whiteSpace: "pre-wrap" }}>{message}</div>
          {children}
          {actionLabel && onAction && (
            <div className="mt-3">
              <Button variant={`outline-${variant}`} size="sm" onClick={onAction}>
                {actionLabel}
              </Button>
            </div>
          )}
        </div>
      </div>
    </Alert>
  );
};

export default GuestStatusCard;
